export const SUPABASE_URL = process.env.NEXT_PUBLIC_SUPABASE_URL;
export const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
export const API_URL = process.env.NEXT_PUBLIC_API_URL;
export const PEARLIVING_ENV = process.env.NEXT_PUBLIC_PEARLIVING_ENV || 'development';
